// eslint-disable-next-line import/no-cycle
import Accordion from './AccordionGroup';

export default Accordion;
